<template>
  <div class="address-contacts" :class="{ 'address-contacts--wrap': wrap }">
    <div
      v-for="(contact, i) in contacts"
      :key="i"
      class="address-contacts__item contacts-item"
    >
      <div class="contacts-item__picture">
        <profile-picture
          :title="contact.full_name"
          :uuid="contact.profile_picture?.uuid"
          :user-firstname="contact.firstname"
        />
      </div>
      <span class="contacts-item__name">{{ contact.full_name }}</span>
    </div>

    <div
      v-if="moreContacts > 0"
      class="address-contacts__more"
    >
      <span>{{ trans('global.plus') }}{{ moreContacts.toString() }}</span>
    </div>

    <div v-if="showLink" class="address-contacts__manage">
      <a :href="contactsLink">{{ trans('addresses.contacts.manage_link') }}</a>
    </div>
  </div>
</template>

<script>
import { URL_ADDRESS_CONTACT_PAGE } from '@tools/routes/routes';
import translation from '@elements/translation';
import ProfilePicture from '@components/ProfilePicture.vue';

export default {
  components: { ProfilePicture },
  mixins: [ translation ],
  props: {
    address: { type: Object, required: true },
    countDisplay: { type: Number, default: 1 },
    showLink: { type: Boolean, default: false },
    wrap: { type: Boolean, default: false },
  },
  data() {
    const contacts = [];
    this.address.contacts.forEach((contact) => {
      if (contacts.length < this.countDisplay) {
        contacts.push(contact.user);
      }
    });
    return {
      contacts,
    };
  },
  computed: {
    contactsLink() {
      return URL_ADDRESS_CONTACT_PAGE.replace('{id}', this.address.id);
    },
    moreContacts() {
      return Math.max(0, this.address.contacts.length - this.countDisplay);
    },
  },
};
</script>
